import { translationKey } from '@change-corgi/core/i18n';
import { useI18n } from '@change-corgi/core/react/i18n';

import { usePageCopy } from 'src/app/pages/psf/promoteOrShare/shared/hooks';
import { useCurrentUser } from 'src/app/shared/hooks/session';

type Result = ModelHookResult<{
	subheadingText2: string;
	description: string;
	subtitle: string;
	items: readonly string[];
}>;

export function useExtendedComboCopy(): Result {
	const { typedTranslate } = useI18n();
	const user = useCurrentUser();
	const {
		data: { subheadingText2 },
	} = usePageCopy();

	const preferredName = user?.firstName || '';

	return {
		data: {
			subheadingText2,
			description: preferredName
				? typedTranslate(translationKey('corgi.psf.promote_or_share.subheading.extended.description.with_name'), {
						name: preferredName,
					})
				: typedTranslate(translationKey('corgi.psf.promote_or_share.subheading.extended.description.without_name')),
			subtitle: typedTranslate(translationKey('corgi.psf.promote_or_share.subheading.extended.subtitle')),
			items: [
				translationKey('corgi.psf.promote_or_share.subheading.extended.items.item_1'),
				translationKey('corgi.psf.promote_or_share.subheading.extended.items.item_2'),
				translationKey('corgi.psf.promote_or_share.subheading.extended.items.item_3'),
			].map((itemKey) => typedTranslate(itemKey)),
		},
	};
}
